import { render, staticRenderFns } from "./InputRangeSelect2.vue?vue&type=template&id=2e6c992c"
import script from "./InputRangeSelect2.vue?vue&type=script&lang=js"
export * from "./InputRangeSelect2.vue?vue&type=script&lang=js"
import style0 from "./InputRangeSelect2.vue?vue&type=style&index=0&id=2e6c992c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports